import React, { createContext, useContext, useState } from 'react'

interface SkillsContextType {
  skillToggles: Record<string, boolean>
  toggleSkill: (skillName: string) => void
  activeSkills: string[]
}

const SkillsContext = createContext<SkillsContextType | undefined>(undefined)

const DEFAULT_SKILLS = {
  'Web Scraper': true,
  'Research': true,
  'Data Analysis': false,
  'Code Review': false,
  'Email Writer': false,
  'Brain Wiki': false,
  'Image Gen': false,
}

export function SkillsProvider({ children }: { children: React.ReactNode }) {
  const [skillToggles, setSkillToggles] = useState<Record<string, boolean>>(DEFAULT_SKILLS)

  const toggleSkill = (skillName: string) => {
    setSkillToggles(prev => ({ ...prev, [skillName]: !prev[skillName] }))
  }

  const activeSkills = Object.entries(skillToggles)
    .filter(([, enabled]) => enabled)
    .map(([name]) => name)

  return (
    <SkillsContext.Provider value={{ skillToggles, toggleSkill, activeSkills }}>
      {children}
    </SkillsContext.Provider>
  )
}

export function useSkills() {
  const context = useContext(SkillsContext)
  if (!context) throw new Error('useSkills must be used within SkillsProvider')
  return context
}
